import { requestHandler } from "../lib/utils/network-client";

export function getCommittees(params = {}) {
  return requestHandler("/committees", {
    params
  });
}

export function createCommittee(payload) {
  return requestHandler("/committees", {
    method: "POST",
    body: payload
  });
}

export function updateCommittee(id, payload) {
  return requestHandler(`/committees/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteCommittee(id) {
  return requestHandler(`/committees/${id}`, {
    method: "DELETE"
  });
}
